export default __webpack_public_path__ + "static/media/slide2.f5abd2cf.jpg";